import { zodResolver } from "@hookform/resolvers/zod";
import {
  useForm,
  type FieldValues,
  type Resolver,
  type UseFormProps,
} from "react-hook-form";
import type { z } from "zod";

export function useZodForm<TSchema extends z.ZodType<FieldValues>>(
  schema: TSchema,
  options?: Omit<UseFormProps<z.output<TSchema>>, "resolver">,
) {
  return useForm<z.output<TSchema>>({
    ...options,
    resolver: zodResolver(schema as never) as unknown as Resolver<
      z.output<TSchema>
    >,
  });
}
